import React, { useEffect, useState } from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  TextField,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import PaperDraggable from "@icarius-common/paperDraggable";
import { useDispatch } from "react-redux";
import ModulesAndMenusTree from "./modulesAndMenusTree";
import { roles } from "@icarius-utils/constants";
import { getModulesTreeAction } from "@icarius-pages/modulesAndMenus/actions";
import { Alert, Autocomplete } from "@material-ui/lab";
import Loader from "@icarius-common/loader";

const TreeDialog = (props) => {

  const {
    open,
    data,
    collaboratorsList,
    isLoading,
    handleClose,
  } = props;

  const [role, setRole] = useState("E");
  const [employee, setEmployee] = useState({});

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getModulesTreeAction(role, employee?.["CODIGO DE EMPLEADO"] || ""));
  }, [dispatch, role, employee])

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      scroll={"paper"}
      maxWidth={"sm"}
      fullWidth
    >
      <DialogTitle style={{ cursor: 'move', paddingRight: 20, width: "95%" }} id="draggable-dialog-title">
        {getLocalizedString("visualizationTree")}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent>
        <Loader open={isLoading} />
        <Grid container item xs={12} spacing={2}>
          <Grid container item xs={12}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel id={'label-role'}>{getLocalizedString("role")}</InputLabel>
              <Select
                value={role}
                labelId={'label-role'}
                id={'select-role'}
                onChange={(e) => setRole(e.target.value)}
                margin={"none"}
              >
                {
                  Object.keys(roles).map((roleName) => ({ key: roles[roleName], value: getLocalizedString(roleName) }))
                    .map(item => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.key}
                        value={item.key}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid container item xs={12}>
            <Autocomplete
              options={collaboratorsList}
              value={employee}
              onChange={(_, newEmployee) => setEmployee(newEmployee)}
              clearOnBlur
              clearText={getLocalizedString("clear")}
              noOptionsText={''}
              getOptionLabel={(employee) => employee["APELLIDO Y NOMBRE"] || ""}
              getOptionSelected={(selected) => Boolean(collaboratorsList.find((employee) => employee["CODIGO DE EMPLEADO"] === selected["CODIGO DE EMPLEADO"]) !== undefined)}
              renderInput={(params) => <TextField {...params} label={getLocalizedString("employee")} />}
              fullWidth
            />
          </Grid>
          {
            !isLoading &&
            <Grid container item xs={12}>
              {
                Boolean(data?.modules?.length) ?
                  <div style={{ height: "50vh", overflow: "auto", width: "100%" }}>
                    <ModulesAndMenusTree
                      data={data}
                    />
                  </div>
                  :
                  <Alert variant="filled" severity="info" style={{ width: '100%' }}>
                    {getLocalizedString("employeeHasNoAcessToRole")}
                  </Alert>
              }
            </Grid>
          }
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction isAccept onClick={handleClose} text={getLocalizedString("close")} />
      </DialogActions>
    </Dialog>
  );
}

export default TreeDialog;